/**
 * Checks if an array is not undefined and has values (other than undefined)
 * @param array any array object
 * @returns True if there the object has at least one value
 */
export const hasValue = <T>(array?: T[] | null): array is T[] =>
  Boolean(array && array.filter((o) => o !== undefined).length > 0);
